import React, { useEffect, useMemo, useState } from "react";
import {
  formatCountdownCompact,
  getCountdownParts,
  pad2,
} from "../../utils/bondWheelHelpers";

const Countdown = ({ deadline, size = "inline", tone = "live", showSpinning = false }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const syncNow = () => setNow(Date.now());
    const id = setInterval(syncNow, 1000);
    document.addEventListener("visibilitychange", syncNow);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", syncNow);
    };
  }, []);

  const parts = useMemo(() => getCountdownParts(deadline, now), [deadline, now]);
  const isSpinning = showSpinning;
  const isPastDue = parts.expired && !showSpinning;
  const displayParts = isPastDue
    ? { expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 }
    : parts;
  const toneClass = isSpinning ? "bw-tone-spin" : isPastDue ? "bw-tone-lock" : tone === "lock" ? "bw-tone-lock" : "bw-tone-live";

  if (size === "hero") {
    if (isSpinning) {
      return (
        <div className="bw-countdown-hero">
          <span className="bw-countdown-spin-label">Spinning</span>
        </div>
      );
    }

    const segments = [];
    if (displayParts.days > 0) {
      segments.push({ value: String(displayParts.days), label: "day" });
    }
    segments.push(
      { value: pad2(displayParts.hours), label: "hr" },
      { value: pad2(displayParts.minutes), label: "min" },
      { value: pad2(displayParts.seconds), label: "sec" }
    );

    return (
      <div className="bw-countdown-hero">
        <div className="bw-countdown-segments">
          {segments.map((segment, index) => (
            <React.Fragment key={`${segment.label}-${index}`}>
              {index > 0 ? <span className="bw-countdown-sep">:</span> : null}
              <div className="bw-countdown-segment">
                <span className={`bw-countdown-digit ${toneClass}`}>{segment.value}</span>
                <span className="bw-countdown-unit">{segment.label}</span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  return (
    <span className={`bw-countdown-inline ${toneClass}`}>
      {isSpinning ? "Spinning" : formatCountdownCompact(deadline, now)}
    </span>
  );
};

export default Countdown;
